import { motion } from "framer-motion";

// Precomputed orbiting nodes (deterministic constellation)
const NODES = [
  { x: 50, y: 12, r: 3.4 },
  { x: 82, y: 30, r: 2.6 },
  { x: 88, y: 66, r: 3 },
  { x: 62, y: 86, r: 2.4 },
  { x: 30, y: 88, r: 3.2 },
  { x: 10, y: 60, r: 2.6 },
  { x: 16, y: 28, r: 3 },
  { x: 50, y: 50, r: 5 }, // core
];
const EDGES = [
  [7, 0], [7, 1], [7, 2], [7, 3], [7, 4], [7, 5], [7, 6],
  [0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 6], [6, 0],
];

export default function NetworkGraphic() {
  return (
    <div className="relative flex h-full w-full items-center justify-center overflow-hidden">
      {/* ambient glow */}
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[55vmin] w-[55vmin] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#10b981]/15 blur-[110px]" />

      {/* rotating concentric rings */}
      {[0, 1, 2].map((i) => (
        <motion.div
          key={i}
          className="absolute rounded-full border border-[#10b981]/20"
          style={{ width: `${34 + i * 16}vmin`, height: `${34 + i * 16}vmin` }}
          animate={{ rotate: i % 2 === 0 ? 360 : -360 }}
          transition={{ duration: 44 + i * 22, repeat: Infinity, ease: "linear" }}
        >
          <span
            className="absolute -top-1 left-1/2 h-2 w-2 -translate-x-1/2 rounded-full bg-[#10b981]"
            style={{ boxShadow: "0 0 12px rgba(16,185,129,0.9)" }}
          />
        </motion.div>
      ))}

      {/* node network */}
      <motion.svg
        viewBox="0 0 100 100"
        className="relative z-10 h-[64vmin] w-[64vmin]"
        animate={{ rotate: 360 }}
        transition={{ duration: 90, repeat: Infinity, ease: "linear" }}
      >
        <g stroke="rgba(16,185,129,0.35)" strokeWidth="0.4">
          {EDGES.map(([a, b], i) => (
            <motion.line
              key={i}
              x1={NODES[a].x}
              y1={NODES[a].y}
              x2={NODES[b].x}
              y2={NODES[b].y}
              initial={{ opacity: 0.15 }}
              animate={{ opacity: [0.15, 0.6, 0.15] }}
              transition={{ duration: 3 + (i % 4), repeat: Infinity, ease: "easeInOut" }}
            />
          ))}
        </g>
        {NODES.map((n, i) => (
          <motion.circle
            key={i}
            cx={n.x}
            cy={n.y}
            r={n.r}
            fill={i === 7 ? "#10b981" : "#8affd6"}
            initial={{ opacity: 0, scale: 0 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.12, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            style={{ filter: "drop-shadow(0 0 3px rgba(16,185,129,0.8))" }}
          />
        ))}
      </motion.svg>

      {/* floating specks */}
      {[...Array(10)].map((_, i) => (
        <motion.span
          key={i}
          className="absolute h-1 w-1 rounded-full bg-[#8affd6]/70"
          style={{ left: `${12 + (i * 8) % 76}%`, top: `${18 + (i * 37) % 64}%` }}
          animate={{ y: [0, -14, 0], opacity: [0.2, 0.8, 0.2] }}
          transition={{ duration: 4 + (i % 5), repeat: Infinity, ease: "easeInOut", delay: i * 0.4 }}
        />
      ))}
    </div>
  );
}
